import { Component, Inject, OnInit } from '@angular/core';
import { FormArray, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { debounceTime } from 'rxjs/operators';
import { ActDatosParticipeService } from 'src/app/services/data/actualizacion-datos/act-datos-participe.service';
import { IActDatosPArticipe, IActDatosPArticipeForm } from 'src/app/services/data/actualizacion-datos/actualizacion-datos.model';
import { GlobalService } from 'src/app/services/global/global.service';
import { UserStoreService } from 'src/app/services/user/user-store.service';

@Component({
  selector: 'app-modal-actualizar-datos',
  templateUrl: './modal-actualizar-datos.component.html',
  styleUrls: ['./modal-actualizar-datos.component.scss']
})
export class ModalActualizarDatosComponent implements OnInit {
  listCus: IActDatosPArticipe[] = [];
  forzado:boolean= false;
  myForm: FormGroup = this._fb.group({
    check: [null],
    arrayCuc: this._fb.array([])
  });
  get frArrayCuc() { return this.myForm.get('arrayCuc') as FormArray; }

  constructor(
    public globalService: GlobalService,
    private userStore: UserStoreService,
    private _actDatosParticipeService: ActDatosParticipeService,
    private dialogRef: MatDialogRef<ModalActualizarDatosComponent>,
    @Inject(MAT_DIALOG_DATA) public data: IActDatosPArticipe[],
    private _fb: FormBuilder
  ) { }

  ngOnInit(): void {
    this.getListCuc();
  }

  // SERVICIOS
  getListCuc() {
    this.listCus = this.data;
    this.listCus.forEach(x => this.addCuc(x));
    this.frArrayCuc.controls[0].get("check").valueChanges.subscribe((val: boolean) => this.validateChangeCheck(val));
    this.frArrayCuc.controls[0].valueChanges.pipe(debounceTime(500)).subscribe((val: IActDatosPArticipeForm) => this.validateChangeFirstCuc(val));
    this.frArrayCuc.controls.forEach((control, index) => control.get("checkPri").valueChanges.subscribe((val) => this.validateChangeCheckPri(val, index)))
  }

  updateDatosActServ(dataOut: IActDatosPArticipe[]) {
    this._actDatosParticipeService.updateActDatos(this.userStore.activeCUC.cuc, dataOut).subscribe({
      next: resp => {        
        localStorage.setItem("rpta_ad", resp.resultado.subCodigo);
        this.dialogRef.close(resp.resultado.codigo == "0");
      },
      error: () => {
        localStorage.setItem("rpta_ad", "-1");
        this.dialogRef.close(false)
      }
    });
  }

  // BOTONES
  btnCloseModal(): void {
    this.dialogRef.close();
  }

  btnUpdate() {
    if (this.validateForm) this.updateDatosActServ(this.buildDataOut(this.frArrayCuc.getRawValue()));
  }

  // LOGICA
  get validateForm(): boolean {
    let resp = true;
    const aux = this.frArrayCuc.getRawValue() as IActDatosPArticipeForm[];
    if(this.frArrayCuc.length > 1 && !aux.some(x => x.checkPri)) {
      this.frArrayCuc.controls.forEach((x, i) => {
        x.get("checkPri").setValue(null, { emitEvent: false });
      });
      resp = false;
    }
    
    if (this.myForm.invalid) {
      this.myForm.markAllAsTouched();
      resp = false;
    }
    return resp;
  }

  buildDataOut(dataUI: IActDatosPArticipeForm[]): IActDatosPArticipe[] {
    return dataUI.map(x => {
      return {
        id: x.id,
        cuc: x.cuc,
        nombre: x.nombre,
        residente: x.residente,
        telefono: x.residente ? x.telefono : "",
        correo: x.correo,
        principal: dataUI.length > 1 ? (x.checkPri ? 1 : 0) : 1,
        forzado: ""
      }
    });
  }

  validateChangeFirstCuc(val: IActDatosPArticipeForm) {
    if (val.check) this.setDataAllForm();
  }

  validateChangeCheck(val: boolean) {
    if (val) this.disabledAllForm();
    else this.enabledAllForm();
  }

  validateChangeCheckPri(_val: boolean, index: number) {
    if (!this.frArrayCuc.controls[0].get("check").value) {
      this.frArrayCuc.controls.forEach((x, i) => {
        if (i !== index) x.get("checkPri").setValue(false, { emitEvent: false });
      });
    }
  }

  // FUNCIONES
  setDataAllForm() {
    this.frArrayCuc.controls.forEach((x, i) => {
      if (i > 0) {
        x.get("correo").setValue(this.frArrayCuc.controls[0].get("correo").value, { emitEvent: false });
        x.get("telefono").setValue(this.frArrayCuc.controls[0].get("telefono").value, { emitEvent: false });
        x.get("checkPri").setValue(false, { emitEvent: false });
      } else {
        x.get("checkPri").setValue(true, { emitEvent: false });
      }
    });
  }

  disabledAllForm() {
    this.frArrayCuc.controls.forEach((x, i) => {
      if (i > 0) x.disable({ emitEvent: false })
    });
  }

  enabledAllForm() {
    this.frArrayCuc.controls.forEach((x, i) => {
      x.enable({ emitEvent: false })
      if (!x.get("residente").value) {
        x.get("telefono").disable({ emitEvent: false })
      }
    });
  }

  addCuc(dataIn: IActDatosPArticipe) {
    this.forzado = dataIn.forzado && dataIn.forzado == "0" ? false : true;
    this.frArrayCuc.push(this._fb.group(
      {
        id: [dataIn.id],
        nombre: [dataIn.nombre],
        residente: [dataIn.residente],
        cuc: [dataIn.cuc],
        telefono: [{ value: dataIn.telefono || null, disabled: !dataIn.residente }, [
          Validators.required,
          Validators.minLength(9),
          Validators.maxLength(9),
          Validators.pattern(/^\d{9}$/)
        ]],
        correo: [dataIn.correo || null, [Validators.required, Validators.pattern(/^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/)]],
        checkPri: [false],
        check: [false],
      }
    ));
  }
}
